export const ADDRESS_FIELD_LABEL = 'Enter an address'
export const STREET_NAME_NUMBER_REGEX = /^\s*([0-9-]+)\s+(.+)/i
export const GOOGLE_ADDRESS_PARTS = {
  street_number: 'short_name', // 124
  route: 'long_name', // main st
  locality: 'long_name', // irvine
  administrative_area_level_1: 'short_name', // CA
  administrative_area_level_2: 'short_name', // Orange County
  sublocality_level_1: 'long_name', // Brooklin
  administrative_area_level_3: 'long_name', // Bruce Township
  sublocality: 'long_name', // Brooklin
  neighborhood: 'long_name', // Bruce Township
  administrative_area_level_4: 'long_name',
  administrative_area_level_5: 'long_name',
  administrative_area_level_6: 'long_name',
  administrative_area_level_7: 'long_name',
  country: 'short_name', // US
  postal_code: 'short_name', // 92627
  subpremise: 'short_name', // Street Unit, Apt, etc
}
export const MAP_GOOGLE_PROPS_TO_FORM_PROPS = {
  street_number: 'street_number', // 124
  route: 'street_name', // main st
  locality: 'municipality', // irvine
  administrative_area_level_1: 'country_primary_subdivision', // CA
  administrative_area_level_2: 'country_secondary_subdivision', // Orange County
  sublocality_level_1: 'municipality', // Brooklin
  administrative_area_level_3: 'municipality', // Bruce Township
  sublocality: 'municipality', // Brooklin
  neighborhood: 'municipality', // Bruce Township
  administrative_area_level_4: 'municipality',
  administrative_area_level_5: 'municipality',
  administrative_area_level_6: 'municipality',
  administrative_area_level_7: 'municipality',
  country: 'country_code', // US
  postal_code: 'postal_code', // 92627
  coordinates: 'coordinates', // coordinates: { lat: 25.7466387, lon: -80.20918180000001 }
  subpremise: 'street_unit', // Street Unit, Apt, etc
}

// For fields that are arrays we want to have them sorted by priority. The first one is the most important
export const MAP_FORM_PROPS_TO_GOOGLE_PROPS = {
  street_number: 'street_number', // 124
  street_name: 'route', // main st
  municipality: [
    'locality',
    'sublocality',
    'sublocality_level_1',
    'administrative_area_level_3',
    'neighborhood',
    'administrative_area_level_4',
    'administrative_area_level_5',
    'administrative_area_level_6',
    'administrative_area_level_7',
  ], // irvine or city equivalent
  country_primary_subdivision: 'administrative_area_level_1', // CA
  country_secondary_subdivision: 'administrative_area_level_2', // Orange County
  country_code: 'country', // US
  postal_code: 'postal_code', // 92627
  street_unit: 'subpremise', // Street Unit, Apt, etc
}
